import { render, staticRenderFns } from "./LayoutAtm.vue?vue&type=template&id=e01ea7a8&scoped=true&"
import script from "./LayoutAtm.vue?vue&type=script&lang=js&"
export * from "./LayoutAtm.vue?vue&type=script&lang=js&"
import style0 from "./LayoutAtm.vue?vue&type=style&index=0&id=e01ea7a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01ea7a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e01ea7a8')) {
      api.createRecord('e01ea7a8', component.options)
    } else {
      api.reload('e01ea7a8', component.options)
    }
    module.hot.accept("./LayoutAtm.vue?vue&type=template&id=e01ea7a8&scoped=true&", function () {
      api.rerender('e01ea7a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/atm/LayoutAtm.vue"
export default component.exports